import { BaseApi, configuration } from 'common/api/BaseApi.ts'
import { callBackend, processError } from 'common/api/fetch.ts'

class BrandingApi extends BaseApi {
  private async uploadFile(url: string, file: File | Blob): Promise<void> {
    const formData = new FormData()
    formData.append('file', file)

    try {
      const response = await callBackend(configuration.basePath + url, {
        method: 'POST',
        body: formData,
      })
      if (!response.ok) throw response
      return await Promise.resolve()
    } catch (err) {
      return await processError(err)
    }
  }

  async uploadLogo(file: File | Blob): Promise<void> {
    return this.uploadFile('/api/custom/logo', file)
  }

  async uploadFavicon(file: File | Blob): Promise<void> {
    return this.uploadFile('/api/custom/favicon', file)
  }
}

export const brandingApi = new BrandingApi()
